import { render, staticRenderFns } from "./order-modal-payments-total-price.vue?vue&type=template&id=16d4c329&scoped=true"
import script from "./order-modal-payments-total-price.vue?vue&type=script&lang=js"
export * from "./order-modal-payments-total-price.vue?vue&type=script&lang=js"
import style0 from "./order-modal-payments-total-price.vue?vue&type=style&index=0&id=16d4c329&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d4c329",
  null
  
)

export default component.exports